import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { FilterCheckboxOptionModel } from "apps-module/app/shared-library/models/filter-checkbox-option.model";

@Component({
    selector: "[pcg-ng-checkbox]",
    templateUrl: "./checkbox.component.html"
})
export class CheckboxComponent {
    public control = new FormControl<boolean>(false);

    public id: string = null;
    @Input("facilityId")
    public set idSetter(value: number){
        this.id = `facility-${value}`;
    }

    public model: FilterCheckboxOptionModel = null;
    @Input("value")
    public set valueSetter(value: FilterCheckboxOptionModel) {
        this.model = value || null;
        this.control.setValue(value?.checked || false);
    }

    @Output()
    public toggle = new EventEmitter<FilterCheckboxOptionModel>();

    public onToggle(): void {
        this.model.checked = this.control.value;
        this.toggle.emit(this.model);
    }
}
